module.exports = __webpack_public_path__ + "img/logo.786b9a3f.png";